module.exports = __webpack_public_path__ + "static/img/strona_023.2f7e71bc.jpg";